import React, { useRef, useState } from 'react';
import { StyleSheet, TextInput } from 'react-native';
import { Button, Dialog } from '@rneui/themed';
import { useTranslation } from 'react-i18next';
import { FontAwesome } from '@expo/vector-icons';

const AddCommentButton = ({ addOrUpdateDailyComment, dailyComment }) => {
  const { t } = useTranslation();
  const [inputVisible, setInputVisible] = useState(false);
  const [text, setText] = useState();
  const isDailyCommentChanged = useRef(false);

  const changeDailyComment = (comment) => {
    isDailyCommentChanged.current = true;
    setText(comment);
  };

  const pressOk = () => {
    if (text && isDailyCommentChanged.current) {
      addOrUpdateDailyComment(text);
    }
    setInputVisible(false);
  };

  const displayInput = () => {
    setText(dailyComment);
    setInputVisible(true);
  };

  return (
    <>
      <Button
        title={t('log.editDialog.dailyThoughts')}
        icon={
          <FontAwesome
            name="pencil-square-o"
            size={26}
            color="white"
            style={{ marginRight: 10 }}
          />
        }
        onPress={displayInput}
      />
      <Dialog
        overlayStyle={styles.overlayStyle}
        isVisible={inputVisible}
        onBackdropPress={() => setInputVisible(false)}
      >
        {/* <Dialog.Title title={t('chat.contactAdvisor')} /> */}
        <TextInput
          style={styles.textInput}
          multiline={true}
          onChangeText={
            text?.length < 1024
              ? (t) => changeDailyComment(t)
              : (t) => changeDailyComment(t.substring(0, t.length - 2))
          }
          value={text}
          placeholder={t('log.editDialog.dailyThoughts')}
          placeholderTextColor="grey"
        />
        <Dialog.Actions>
          <Dialog.Button title={t('ok')} type="solid" onPress={pressOk} />
          <Dialog.Button
            title={t('cancel')}
            type="outline"
            onPress={() => setInputVisible(false)}
          />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

const styles = StyleSheet.create({
  overlayStyle: {
    backgroundColor: 'white',
    width: '90%',
    height: '90%',
  },
  textInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: 'grey',
    padding: 10,
    borderRadius: 3,
    fontSize: 18,
  },
});

export default AddCommentButton;
